/* eslint-disable react/no-array-index-key */
/* eslint-disable no-plusplus */
/* eslint-disable no-param-reassign */
/* eslint-disable jsx-a11y/alt-text */
/* eslint-disable jsx-a11y/click-events-have-key-events */
/* eslint-disable jsx-a11y/no-static-element-interactions */
/* eslint-disable react/forbid-prop-types */
/* eslint-disable array-callback-return */
/* eslint-disable consistent-return */
/* eslint-disable no-unused-vars */
/* eslint-disable react/prop-types */
/* eslint-disable react/destructuring-assignment */
import React, { useEffect, useRef, useState } from 'react';
import { Row, Col } from 'react-bootstrap';
import PropTypes from 'prop-types';
import AppTextInput from '../../../shared/components/app-text-input/AppTextInput';
import AppButton from '../../../shared/components/app-button/AppButton';
import AppAsyncSelect from '../../../shared/components/app-async-select/AppAsyncSelect';
import AppSelect from '../../../shared/components/app-select/AppSelect';
import { getAirportsApi } from '../../../api/flightApi';
import { debounce } from '../../../api/apiUtils';
import AppNumberInput from '../../../shared/components/app-number-input/AppNumberInput';
import AppDatePicker from '../../../shared/components/app-date-picker/AppDatePicker';
import { addAgentSeriesFareCouponApi } from '../../../api/profileApi';
import {
  formatDate,
  formatTimeString,
  getNewDate,
  isEmpty,
} from '../../../shared/helper-utils/appUtils';
import {
  API_DATE_FORMAT,
  TODAY_DATE,
} from '../../../shared/constants/Constants';
import AppLoading from '../../../shared/components/app-loading/AppLoading';
import AppAlert from '../../../shared/components/app-alert/AppAlert';
import { getUserAgentId } from '../../../shared/helper-utils/localStorage';
import '../../flights/ModifySearch.scss';

const DEBOUNCE_DELAY = 500;

const CARRIER_OPTIONS = [
  { label: '6E', value: '6E' },
  { label: 'G8', value: 'G8' },
  { label: 'SG', value: 'SG' },
  { label: 'I5', value: 'I5' },
  { label: 'IX', value: 'IX' },
  { label: 'AI', value: 'AI' },
  { label: 'UK', value: 'UK' },
  { label: 'S9', value: 'S9' },
  { label: 'QP', value: 'QP' },
  { label: '9I', value: '9I' },
];

const TRAVEL_TYPE = [
  { label: 'Domestic', value: 'domestic' },
  { label: 'International', value: 'international' },
];

const YES_NO = [
  { label: 'Yes', value: 'yes' },
  { label: 'No', value: 'no' },
];
const YES_NO_SMALL = [
  { label: 'Yes', value: 'Y' },
  { label: 'No', value: 'N' },
];
const TRUE_FALSE = [
  { label: 'True', value: 'true' },
  { label: 'False', value: 'false' },
];
const JOURNEY_TYPE = [
  { label: 'One Way', value: 'Oneway' },
  { label: 'Round Trip', value: 'RoundTrip' },
];

export function AirportOption(props) {
  return (
    <div
      onClick={() => props.selectOption(props?.data)}
      className={`${props?.isFocused ? 'airport-focused' : ''} airport-option`}
      key={props?.value}
    >
      <div className="d-flex justify-content-between p-1">
        <div className="airport-city-details">
          <div className="fs-14 d-flex align-items-center">
            <span className="airport-option_country-code">
              {props?.data?.AirportCode}
            </span>
            <span>{props?.data?.AirportLocation?.split(',')[0]}</span>
          </div>
          <div className="airport-option_airport-name">
            {props?.data?.AirportName}
          </div>
        </div>
        <div className="d-flex align-items-center justify-content-end fs-12 airport-country-details gap-1">
          <span>{props?.data?.Country}</span>
          <img
            src={`https://cdn.jsdelivr.net/gh/lipis/flag-icons/flags/4x3/${props?.data?.CountryCode?.toLowerCase()}.svg`}
          />
        </div>
      </div>
    </div>
  );
}

function AddCoupon({ cloneCoupon, onRefreshForNewCoupons }) {
  const originAirportRef = useRef(null);
  const destinationAirportRef = useRef(null);
  const [showCouponDetails, setSHowCouponDetails] = useState(true);
  const [isLoading, setIsLoading] = useState(false);
  const [showSectorDetails, setShowSectorDetails] = useState(false);
  const [alert, setAlert] = useState(undefined);
  const [isCouponDetailsAdded, setIsCuponDetailsAdded] = useState(false);
  const [couponDetails, setCouponDetails] = useState({
    coupon_origin: '',
    coupon_destination: '',
    issingledate: 'no',
    validjdates: '', // start date
    validjdates_end: '', // end date
    coupon_validity: '', // end date
    coupon_class: '',
    isconnecting: 'true',
    numcoupons_booklet: 0,
    totalcoupons: '',
    availablecoupons: '',
    addedby: getUserAgentId(),
    agentid: getUserAgentId(),
    carriercode: '',
    status: 'active',
    basefare: '0',
    tax: '0',
    yq: '0',
    domint: 'domestic',
    total_amount: '0',
    flightnumber: '',
    deptime: '',
    arrtime: '',
    totalduration: '',
    checkrealtimeavail: 'true',
    realtimeavail_supplierid: getUserAgentId(),
    childbasefare: '0',
    childyq: '0',
    childtax: '0',
    infantbasefare: '0',
    infantyq: '0',
    infanttax: '1750',
    hiddenmarkup: '0',
    coupontype: 'series',
    checkliveavail: 'yes',
    jtype: 'Oneway',
    issplrt: 'false',
    isdaywiseavail: 'true',
    fullflightinfostr: '-',
    availabledays: 'all',
    gds_pnr: 'auto',
    autoissuance: '',
    email: '',
  });
  const [sectorDetails, setSectorDetails] = useState({
    coupon_sectors: [
      {
        carrier: '',
        flight_number: '',
        booking_class: '',
        origin: '',
        destination: '',
        airport_endterminal: '',
        daychange: 'Y',
        jdate: '',
        flight_type: 'onward',
        stop_over: '',
        operatedby: '',
        baggageinfo: '',
        flight_model: '',
        airport_terminal: '',
        refundable: '',
        refundable_info: '',
        departure_time: '',
        arrival_time: '',
        sector_number: '',
        sector_duration: '',
        selectedOrigin: '',
        selectedDestination: '',
      },
    ],
  });
  const [addedCouponId, setAddedCouponId] = useState(';');

  const calculateDuration = (dep, arr) => {
    const [depHours, depMinutes] = dep.split(':').map(Number);
    const [arrHours, arrMinutes] = arr.split(':').map(Number);
    const depDate = new Date();
    depDate.setHours(depHours, depMinutes, 0, 0);

    const arrDate = new Date();
    arrDate.setHours(arrHours, arrMinutes, 0, 0);

    // Calculate difference in milliseconds
    let durationMs = arrDate - depDate;

    // Handle overnight cases
    if (durationMs < 0) {
      durationMs += 24 * 60 * 60 * 1000; // Add 24 hours in ms
    }

    // Convert to minutes
    const durationMinutes = Math.floor(durationMs / (1000 * 60));
    return durationMinutes;
  };

  const handleCalculateDuration = (name, value) => {
    if (name === 'deptime' && !isEmpty(couponDetails.arrtime)) {
      const departure = value;
      const arrival = couponDetails.arrtime;
      const duration = calculateDuration(departure, arrival);
      setCouponDetails((prev) => ({
        ...prev,
        totalduration: duration,
      }));
    }
    if (name === 'arrtime' && !isEmpty(couponDetails.deptime)) {
      const arrival = value;
      const departure = couponDetails.deptime;
      const duration = calculateDuration(departure, arrival);
      setCouponDetails((prev) => ({
        ...prev,
        totalduration: duration,
      }));
    }
  };
  const calculateDurationForSector = (name, value, index) => {
    if (
      name === 'departure_time' &&
      !isEmpty(sectorDetails.coupon_sectors[index].arrival_time)
    ) {
      const departure = value;
      const arrival = sectorDetails.coupon_sectors[index].arrival_time;
      return calculateDuration(departure, arrival);
    }
    if (
      name === 'arrival_time' &&
      !isEmpty(sectorDetails.coupon_sectors[index].departure_time)
    ) {
      const arrival = value;
      const departure = sectorDetails.coupon_sectors[index].departure_time;
      return calculateDuration(departure, arrival);
    }
  };

  const handleUpdateCoupon = (name, value) => {
    if (name === 'domint') {
      setCouponDetails((prev) => ({
        ...prev,
        [name]: value,
        carriercode: '',
      }));
      return;
    }
    if (name === 'deptime' || name === 'arrtime') {
      handleCalculateDuration(name, value);
    }
    if (name === 'tax') {
      setCouponDetails((prev) => ({
        ...prev,
        [name]: value,
        childtax: value,
      }));
      return;
    }
    if (name === 'validjdates') {
      setCouponDetails((prev) => ({
        ...prev,
        [name]: value,
        validjdates_end: value,
      }));
      return;
    }
    setCouponDetails((prev) => ({
      ...prev,
      [name]: value,
    }));
  };

  useEffect(() => {
    if (cloneCoupon && Object.keys(cloneCoupon).length > 0) {
      originAirportRef.current = {
        label: cloneCoupon.CouponOrigin,
        value: cloneCoupon.CouponOrigin,
        AirportLocation: cloneCoupon.CouponOrigin,
      };
      destinationAirportRef.current = {
        label: cloneCoupon.CouponDestination,
        value: cloneCoupon.CouponDestination,
        AirportLocation: cloneCoupon.CouponDestination,
      };
      setCouponDetails((prev) => ({
        ...prev,
        coupon_origin: cloneCoupon.CouponOrigin,
        coupon_destination: cloneCoupon.CouponDestination,
        domint: cloneCoupon.DomInt,
        carriercode: cloneCoupon.CarrierCode,
        flightnumber: cloneCoupon.FlightNumber,
        coupon_class: cloneCoupon.CouponClass,
        deptime: formatTimeString(cloneCoupon.Deptime),
        arrtime: formatTimeString(cloneCoupon.Arrtime),
        totalduration: cloneCoupon.TotalDuration,
        availablecoupons: cloneCoupon.AvailableCoupons,
        validjdates: cloneCoupon.ValidJdates,
        tax: cloneCoupon.Tax,
        total_amount: cloneCoupon.TotalAmount,
        childtax: cloneCoupon.Tax,
        infanttax: cloneCoupon.InfantTax,
      }));
    }
  }, [cloneCoupon]);

  const loadAirportSuggestions = debounce(async (query, callback) => {
    let airports = [];
    if (query.length >= 3) {
      const response = await getAirportsApi(query);
      airports = response.map((airportNode) => ({
        label: `${airportNode.AirportCode} - ${airportNode.AirportLocation}`,
        value: airportNode.AirportCode,
        ...airportNode,
      }));
    }
    callback(airports);
  }, DEBOUNCE_DELAY);

  const handleAirportSelect = (airport, name) => {
    if (name === 'origin') {
      originAirportRef.current = airport;
      let originAirportCode = '';
      if (airport !== null) {
        originAirportCode = airport.value;
      }
      handleUpdateCoupon('coupon_origin', originAirportCode);
    } else {
      destinationAirportRef.current = airport;
      let destinationAirportCode = '';
      if (airport !== null) {
        destinationAirportCode = airport.value;
      }
      handleUpdateCoupon('coupon_destination', destinationAirportCode);
    }
  };

  const getFormattedTime = (time) => {
    const timeWithoutSymbol = time.replace(':', '');
    return parseInt(timeWithoutSymbol, 10);
  };

  const handleAddCoupon = async () => {
    if (
      isEmpty(couponDetails.coupon_origin) ||
      isEmpty(couponDetails.coupon_destination) ||
      isEmpty(couponDetails.carriercode) ||
      isEmpty(couponDetails.availablecoupons) ||
      isEmpty(couponDetails.numcoupons_booklet) ||
      isEmpty(couponDetails.coupon_class) ||
      isEmpty(couponDetails.validjdates_end) ||
      isEmpty(couponDetails.hiddenmarkup) ||
      isEmpty(couponDetails.validjdates) ||
      isEmpty(couponDetails.totalduration) ||
      isEmpty(couponDetails.arrtime) ||
      isEmpty(couponDetails.deptime) ||
      isEmpty(couponDetails.flightnumber)
    ) {
      setAlert({
        variant: 'error',
        title: 'Add Coupon',
        description: 'Enter all Required details',
      });
      return false;
    }
    const req = {
      ...couponDetails,
    };
    req.deptime = getFormattedTime(couponDetails.deptime);
    req.arrtime = getFormattedTime(couponDetails.arrtime);
    req.coupon_validity = req.validjdates_end;
    req.totalcoupons = req.availablecoupons;
    const secDetails = {
      carrier: couponDetails.carriercode,
      flight_number: couponDetails.flightnumber,
      booking_class: couponDetails.coupon_class,
      origin: couponDetails.coupon_origin,
      destination: couponDetails.coupon_destination,
      airport_endterminal: '',
      daychange: 'Y',
      jdate: couponDetails.validjdates_end,
      flight_type: 'onward',
      stop_over: '',
      operatedby: '',
      baggageinfo: '',
      flight_model: '',
      airport_terminal: '',
      refundable: 'N',
      refundable_info: '',
      departure_time: couponDetails.deptime,
      arrival_time: couponDetails.arrtime,
      sector_number: '',
      sector_duration: couponDetails.totalduration,
      selectedOrigin: originAirportRef.current,
      selectedDestination: destinationAirportRef.current,
    };
    setSectorDetails({
      coupon_sectors: [{ ...secDetails }],
    });
    setSHowCouponDetails(false);
    setShowSectorDetails(true);
  };

  const handleAddSector = () => {
    const secDetails = [...sectorDetails.coupon_sectors];
    const obj = {
      carrier: '',
      flight_number: '',
      booking_class: '',
      origin: '',
      destination: '',
      airport_endterminal: '',
      daychange: 'Y',
      jdate: '',
      flight_type: 'onward',
      stop_over: '',
      operatedby: '',
      baggageinfo: '',
      flight_model: '',
      airport_terminal: '',
      refundable: 'N',
      refundable_info: '',
      departure_time: '',
      arrival_time: '',
      sector_number: '',
      sector_duration: '',
      selectedOrigin: '',
      selectedDestination: '',
    };
    secDetails.push(obj);
    setSectorDetails((prev) => ({
      ...prev,
      coupon_sectors: [...secDetails],
    }));
  };

  const handleRemoveSector = (index) => {
    const secDetails = [...sectorDetails.coupon_sectors];
    secDetails.splice(index, 1);
    setSectorDetails((prev) => ({
      ...prev,
      coupon_sectors: [...secDetails],
    }));
  };

  const handleUpdateSector = (name, value, index) => {
    const secDetails = [...sectorDetails.coupon_sectors];
    secDetails[index][name] = value || '';
    if (name === 'departure_time' || name === 'arrival_time') {
      const duration = calculateDurationForSector(name, value, index);
      secDetails[index].sector_duration = duration;
    }
    setSectorDetails((prev) => ({
      ...prev,
      coupon_sectors: [...secDetails],
    }));
  };

  const handleAirportSelectForSector = (data, name, index) => {
    const secDetails = [...sectorDetails.coupon_sectors];
    if (name === 'origin') {
      secDetails[index].origin = data?.value;
      secDetails[index].selectedOrigin = data;
    }
    if (name === 'destination') {
      secDetails[index].destination = data?.value;
      secDetails[index].selectedDestination = data;
    }
    setSectorDetails((prev) => ({
      ...prev,
      coupon_sectors: [...secDetails],
    }));
  };

  const handleAddSectorDetails = async () => {
    setIsLoading(true);
    const reqArr = [];
    sectorDetails.coupon_sectors.forEach((x) => {
      reqArr.push({ ...x });
    });
    reqArr.forEach((x, index) => {
      delete x.selectedOrigin;
      delete x.selectedDestination;
      x.sector_number = `${index}`;
      x.departure_time = getFormattedTime(x.departure_time);
      x.arrival_time = getFormattedTime(x.arrival_time);
    });
    let isError = false;
    const isValidationError = false;
    for (let i = 0; i < reqArr.length; i++) {
      if (
        isEmpty(reqArr[i].origin) ||
        isEmpty(reqArr[i].destination) ||
        isEmpty(reqArr[i].carrier) ||
        isEmpty(reqArr[i].flight_number) ||
        isEmpty(reqArr[i].booking_class) ||
        isEmpty(reqArr[i].flight_type) ||
        isEmpty(reqArr[i].departure_time) ||
        isEmpty(reqArr[i].arrival_time) ||
        isEmpty(reqArr[i].sector_duration)
      ) {
        isError = true;
        setIsLoading(false);
      }
    }
    if (isError) {
      setAlert({
        variant: 'error',
        title: 'Add Coupon Sector',
        description: 'Please enter all required details',
      });
      return;
    }
    if (isValidationError) {
      setAlert({
        variant: 'error',
        title: 'Add Coupon Sector',
        description: 'Please enter all valid details',
      });
      return;
    }
    if (
      isEmpty(couponDetails.coupon_origin) ||
      isEmpty(couponDetails.coupon_destination) ||
      isEmpty(couponDetails.carriercode) ||
      isEmpty(couponDetails.availablecoupons) ||
      isEmpty(couponDetails.numcoupons_booklet) ||
      isEmpty(couponDetails.coupon_class) ||
      isEmpty(couponDetails.validjdates_end) ||
      isEmpty(couponDetails.hiddenmarkup) ||
      isEmpty(couponDetails.validjdates) ||
      isEmpty(couponDetails.totalduration) ||
      isEmpty(couponDetails.arrtime) ||
      isEmpty(couponDetails.deptime) ||
      isEmpty(couponDetails.flightnumber)
    ) {
      setAlert({
        variant: 'error',
        title: 'Add Coupon',
        description: 'Enter all Required details',
      });
      return false;
    }
    const req = {
      ...couponDetails,
    };
    req.deptime = getFormattedTime(couponDetails.deptime);
    req.arrtime = getFormattedTime(couponDetails.arrtime);
    req.coupon_validity = req.validjdates_end;
    req.totalcoupons = req.availablecoupons;
    const res = await addAgentSeriesFareCouponApi(req, reqArr);
    if (res && res.Root && res.Root.Status === 'OK') {
      setAlert({
        variant: 'success',
        title: 'Add Coupon',
        description: res?.Root?.Result || 'Coupon added successfully',
      });
      setTimeout(() => {
        onRefreshForNewCoupons();
      }, 1500);
    } else {
      setAlert({
        variant: 'error',
        title: 'Add Coupon',
        description: res?.Root?.Result || 'Failed to add coupon',
      });
    }
    setIsLoading(false);
  };

  const getMinDateForSector = (index) => {
    try {
      if (index === 0) {
        const sectorMinDate = getNewDate(TODAY_DATE);
        return sectorMinDate;
      }
      const sectorMinDate = sectorDetails.coupon_sectors[index - 1].jdate;
      if (!isEmpty(sectorMinDate)) {
        const formattedDate = getNewDate(sectorMinDate);
        return formattedDate;
      }
      return getNewDate(TODAY_DATE);
    } catch (error) {
      return '';
    }
  };

  return (
    <div>
      {alert && (
        <AppAlert
          showIcon
          variant={alert.variant}
          title={alert.title}
          description={alert.description}
          onHide={() => {
            setAlert(undefined);
          }}
        />
      )}
      <AppLoading isLoading={isLoading} />
      {showCouponDetails && (
        <div className="add-coupon p-3">
          <div className="add-coupon_details ">
            <div className="add-coupon_details_header">Coupon Details</div>
            <div className="add-coupon_details_content mt-3 fs-14">
              <Row className="spacing-8-special mb-2">
                <Col lg={3} md={3} sm={6} xs={6}>
                  <AppAsyncSelect
                    placeholder=""
                    className="add-coupon-async-select"
                    labelClassName="add-coupon-async-select_label"
                    components={{ Option: AirportOption }}
                    label="Enter Origin *"
                    menuWidth="320px !important"
                    height="42px"
                    name="origin"
                    loadOptionsFn={loadAirportSuggestions}
                    onSelect={handleAirportSelect}
                    selectedValue={originAirportRef.current}
                  />
                </Col>
                <Col lg={3} md={3} sm={6} xs={6}>
                  <AppAsyncSelect
                    placeholder=""
                    className="add-coupon-async-select"
                    labelClassName="add-coupon-async-select_label"
                    components={{ Option: AirportOption }}
                    label="Enter Destination *"
                    menuWidth="320px !important"
                    height="42px"
                    name="destination"
                    loadOptionsFn={loadAirportSuggestions}
                    onSelect={handleAirportSelect}
                    selectedValue={destinationAirportRef.current}
                  />
                </Col>
                <Col lg={3} md={3} sm={6} xs={6}>
                  <AppSelect
                    name="travelType"
                    id="travelType"
                    label="Journey Type"
                    placeholder=""
                    required
                    isClearable={false}
                    selectedValue={couponDetails.domint}
                    options={TRAVEL_TYPE}
                    onSelect={(d) => handleUpdateCoupon('domint', d.value)}
                  />
                </Col>
                <Col lg={3} md={3} sm={6} xs={6}>
                  {couponDetails.domint === 'domestic' ? (
                    <AppSelect
                      name="carrier"
                      id="carrier"
                      label="Carrier"
                      placeholder=""
                      required
                      isClearable={false}
                      selectedValue={couponDetails.carriercode}
                      onSelect={(d) =>
                        handleUpdateCoupon('carriercode', d.value)
                      }
                      options={CARRIER_OPTIONS}
                    />
                  ) : (
                    <AppTextInput
                      name="carriercode"
                      id="carriercode"
                      required
                      label="Carrier"
                      value={couponDetails.carriercode}
                      onChange={(e) =>
                        handleUpdateCoupon('carriercode', e.target.value)
                      }
                    />
                  )}
                </Col>
                <Col lg={3} md={3} sm={6} xs={6}>
                  <AppTextInput
                    name="flightNumber"
                    id="flightNumber"
                    required
                    label="Flight Number"
                    value={couponDetails.flightnumber}
                    onChange={(e) =>
                      handleUpdateCoupon('flightnumber', e.target.value)
                    }
                  />
                </Col>
                <Col lg={3} md={3} sm={6} xs={6}>
                  <AppTextInput
                    name="class"
                    id="class"
                    required
                    label="Class"
                    placeholderText=""
                    value={couponDetails.coupon_class}
                    onChange={(e) =>
                      handleUpdateCoupon('coupon_class', e.target.value)
                    }
                  />
                </Col>
                <Col lg={3} md={3} sm={6} xs={6}>
                  <AppTextInput
                    name="deptime"
                    id="deptime"
                    type="time"
                    required
                    label="Dep Time(HHMM)"
                    value={couponDetails.deptime}
                    onChange={(e) =>
                      handleUpdateCoupon('deptime', e.target.value)
                    }
                  />
                </Col>
                <Col lg={3} md={3} sm={6} xs={6}>
                  <AppTextInput
                    name="arrtime"
                    id="arrtime"
                    type="time"
                    required
                    label="Arr Time(HHMM)"
                    value={couponDetails.arrtime}
                    onChange={(e) =>
                      handleUpdateCoupon('arrtime', e.target.value)
                    }
                  />
                </Col>
                <Col lg={3} md={3} sm={6} xs={6}>
                  <AppNumberInput
                    name="duration"
                    id="duration"
                    required
                    label="Total Duration(Minutes)"
                    value={couponDetails.totalduration}
                    onChange={(e) => handleUpdateCoupon('totalduration', e)}
                  />
                </Col>
                {/* <Col lg={3} md={3} sm={6} xs={12}>
                  <AppSelect
                    name="status"
                    id="status"
                    label="Status"
                    placeholder=""
                    required
                    isClearable={false}
                    selectedValue={couponDetails.status}
                    options={STATUS_TYPE}
                    onSelect={(d) => handleUpdateCoupon('status', d.value)}
                  />
                </Col> */}
                <Col lg={3} md={3} sm={6} xs={6}>
                  <AppNumberInput
                    name="availablecoupons"
                    id="availablecoupons"
                    required
                    label="Available Seats"
                    value={couponDetails.availablecoupons}
                    onChange={(d) => handleUpdateCoupon('availablecoupons', d)}
                  />
                </Col>
                <Col lg={3} md={3} sm={6} xs={6}>
                  <AppDatePicker
                    name="jdate"
                    labelClassName="booking-date-label"
                    id="jdate"
                    required
                    label="Journey Date"
                    className="app-date-picker"
                    customClassName=" position-relative flight-booking-picker"
                    minDate={getNewDate(TODAY_DATE)}
                    selectedDate={
                      !isEmpty(couponDetails.validjdates) &&
                      getNewDate(couponDetails.validjdates)
                    }
                    onChange={(date) =>
                      handleUpdateCoupon(
                        'validjdates',
                        formatDate(getNewDate(date), API_DATE_FORMAT),
                      )
                    }
                  />
                </Col>
                <Col lg={3} md={3} sm={6} xs={6}>
                  <AppDatePicker
                    name="endjourneydate"
                    id="endjourneydate"
                    required
                    label="End Journey Date"
                    labelClassName="booking-date-label"
                    className="app-date-picker"
                    customClassName=" position-relative flight-booking-picker"
                    minDate={
                      !isEmpty(couponDetails.validjdates) &&
                      getNewDate(couponDetails.validjdates)
                    }
                    selectedDate={
                      !isEmpty(couponDetails.validjdates_end) &&
                      getNewDate(couponDetails.validjdates_end)
                    }
                    onChange={(date) =>
                      handleUpdateCoupon(
                        'validjdates_end',
                        formatDate(getNewDate(date), API_DATE_FORMAT),
                      )
                    }
                  />
                </Col>
              </Row>
            </div>
          </div>
          <div className="add-coupon_details ">
            <div className="add-coupon_details_header">Fare Details</div>
            <div className="add-coupon_details_content mt-3 fs-14">
              <Row className=" spacing-8-special mb-2">
                {/* <Col lg={3} md={6} sm={6} xs={12}>
                  <AppTextInput
                    name="totalamount"
                    id="totalamount"
                    // required
                    label="Total Amount"
                    value={couponDetails.total_amount}
                    onChange={(e) =>
                      handleUpdateCoupon('total_amount', e.target.value)
                    }
                  />
                </Col> */}
                <Col lg={3} md={6} sm={6} xs={6}>
                  <AppTextInput
                    name="tax"
                    id="tax"
                    // required
                    label="Adult/Child Tax"
                    value={couponDetails.tax}
                    onChange={(e) => handleUpdateCoupon('tax', e.target.value)}
                  />
                </Col>
                {/* <Col lg={3} md={6} sm={6} xs={12}>
                  <AppTextInput
                    name="childtax"
                    id="childtax"
                    // required
                    label="Child Tax"
                    value={couponDetails.childtax}
                    onChange={(e) =>
                      handleUpdateCoupon('childtax', e.target.value)
                    }
                  />
                </Col> */}
                <Col lg={3} md={6} sm={6} xs={6}>
                  <AppTextInput
                    name="infanttax"
                    id="infanttax"
                    // required
                    label="Infant Tax"
                    value={couponDetails.infanttax}
                    onChange={(e) =>
                      handleUpdateCoupon('infanttax', e.target.value)
                    }
                  />
                </Col>
                {couponDetails.jtype === 'RoundTrip' && (
                  <Col lg={3} md={6} sm={6} xs={6}>
                    <AppSelect
                      name="splRT"
                      id="splRT"
                      label="Spl RT"
                      placeholder=""
                      // required
                      isClearable={false}
                      selectedValue={couponDetails.issplrt}
                      options={TRUE_FALSE}
                      onSelect={(d) => handleUpdateCoupon('issplrt', d.value)}
                    />
                  </Col>
                )}
              </Row>
            </div>
          </div>
          <div className="d-flex justify-content-center">
            <AppButton
              btnText="Continue"
              variant="primary"
              className="px-4"
              onClick={handleAddCoupon}
            />
          </div>
        </div>
      )}
      {showSectorDetails && (
        <div className="add-coupon p-3">
          <div className="add-coupon_details_header">Sector Details</div>
          <div className="add-coupon_details_content mt-3 fs-14">
            {sectorDetails.coupon_sectors.map((d, index) => (
              <Row className="spacing-8-special mb-3" key={index}>
                <Col lg={3} md={3} sm={6} xs={6}>
                  <AppAsyncSelect
                    placeholder=""
                    className="add-coupon-async-select"
                    labelClassName="add-coupon-async-select_label"
                    components={{ Option: AirportOption }}
                    label="Origin *"
                    menuWidth="320px !important"
                    height="42px"
                    name="origin"
                    loadOptionsFn={loadAirportSuggestions}
                    onSelect={(airport, name) =>
                      handleAirportSelectForSector(airport, name, index)
                    }
                    selectedValue={d.selectedOrigin}
                  />
                </Col>
                <Col lg={3} md={3} sm={6} xs={6}>
                  <AppAsyncSelect
                    placeholder=""
                    className="add-coupon-async-select"
                    labelClassName="add-coupon-async-select_label"
                    components={{ Option: AirportOption }}
                    label="Destination *"
                    menuWidth="320px !important"
                    height="42px"
                    name="destination"
                    loadOptionsFn={loadAirportSuggestions}
                    onSelect={(airport, name) =>
                      handleAirportSelectForSector(airport, name, index)
                    }
                    selectedValue={d.selectedDestination}
                  />
                </Col>
                <Col lg={3} md={3} sm={6} xs={6}>
                  <AppSelect
                    name="carrier"
                    id="carrier"
                    label="Carrier"
                    placeholder=""
                    required
                    isClearable={false}
                    selectedValue={d.carrier}
                    onSelect={(e) =>
                      handleUpdateSector('carrier', e.value, index)
                    }
                    options={CARRIER_OPTIONS}
                  />
                </Col>
                <Col lg={3} md={3} sm={6} xs={6}>
                  <AppTextInput
                    placeholderText=""
                    label="Flight Number *"
                    value={d.flight_number}
                    onChange={(e) =>
                      handleUpdateSector('flight_number', e.target.value, index)
                    }
                  />
                </Col>
                <Col lg={3} md={3} sm={6} xs={6}>
                  <AppTextInput
                    placeholderText=""
                    label="Class *"
                    value={d.booking_class}
                    onChange={(e) =>
                      handleUpdateSector('booking_class', e.target.value, index)
                    }
                  />
                </Col>
                <Col lg={3} md={3} sm={6} xs={6}>
                  <AppSelect
                    name="flightType"
                    label="Flight Type *"
                    placeholder=""
                    selectedValue={d.flight_type}
                    options={[
                      { value: 'onward', label: 'Onward' },
                      { value: 'return', label: 'Return' },
                    ]}
                    onSelect={(e) =>
                      handleUpdateSector('flight_type', e.value, index)
                    }
                    isClearable={false}
                  />
                </Col>
                <Col lg={3} md={3} sm={6} xs={6}>
                  <AppTextInput
                    name="departure_time"
                    id="departure_time"
                    type="time"
                    required
                    label="Dep.Time *"
                    value={d.departure_time}
                    onChange={(e) =>
                      handleUpdateSector(
                        'departure_time',
                        e.target.value,
                        index,
                      )
                    }
                  />
                </Col>
                <Col lg={3} md={3} sm={6} xs={6}>
                  <AppTextInput
                    placeholderText=""
                    type="time"
                    required
                    label="Arr.Time *"
                    value={d.arrival_time}
                    onChange={(e) =>
                      handleUpdateSector('arrival_time', e.target.value, index)
                    }
                  />
                </Col>

                <Col lg={3} md={3} sm={6} xs={6}>
                  <AppTextInput
                    placeholderText=""
                    label="Duration *"
                    value={d.sector_duration}
                    onChange={(e) =>
                      handleUpdateSector(
                        'sector_duration',
                        e.target.value,
                        index,
                      )
                    }
                  />
                </Col>
                <Col lg={3} md={3} sm={6} xs={6}>
                  <AppSelect
                    name="refundable"
                    placeholder=""
                    label="Refundable *"
                    selectedValue={d.refundable}
                    options={[
                      { value: 'Y', label: 'Refundable' },
                      { value: 'N', label: 'Non Refundable' },
                    ]}
                    onSelect={(e) =>
                      handleUpdateSector('refundable', e.value, index)
                    }
                    isClearable={false}
                  />
                </Col>
                <Col lg={3} md={3} sm={6} xs={6}>
                  <AppTextInput
                    placeholderText=""
                    label="Start Terminal"
                    value={d.airport_terminal}
                    onChange={(e) =>
                      handleUpdateSector(
                        'airport_terminal',
                        e.target.value,
                        index,
                      )
                    }
                  />
                </Col>
                <Col lg={3} md={3} sm={6} xs={6}>
                  <AppTextInput
                    placeholderText=""
                    label="End Terminal"
                    value={d.airport_endterminal}
                    onChange={(e) =>
                      handleUpdateSector(
                        'airport_endterminal',
                        e.target.value,
                        index,
                      )
                    }
                  />
                </Col>
                <Col lg={3} md={3} sm={6} xs={12}>
                  <AppDatePicker
                    name="J.Date"
                    id="J.Date"
                    label="J.Date *"
                    labelClassName="booking-date-label"
                    className="app-date-picker"
                    customClassName=" position-relative flight-booking-picker"
                    selectedDate={!isEmpty(d.jdate) && getNewDate(d.jdate)}
                    minDate={getMinDateForSector(index)}
                    onChange={(date) =>
                      handleUpdateSector(
                        'jdate',
                        formatDate(getNewDate(date), API_DATE_FORMAT),
                        index,
                      )
                    }
                  />
                </Col>
                <Col lg={3} md={3} sm={6} xs={6}>
                  <AppSelect
                    name="daychange"
                    placeholder=""
                    label="Day Change *"
                    selectedValue={d.daychange}
                    options={YES_NO_SMALL}
                    onSelect={(e) =>
                      handleUpdateSector('daychange', e.value, index)
                    }
                    isClearable={false}
                  />
                </Col>
                <Col lg={3} md={3} sm={6} xs={6}>
                  {index === 0 ? (
                    <AppButton
                      btnText="Add Sector"
                      variant="outlined"
                      onClick={handleAddSector}
                    />
                  ) : (
                    <AppButton
                      btnText="Remove"
                      variant="outlined"
                      onClick={() => handleRemoveSector(index)}
                    />
                  )}
                </Col>
              </Row>
            ))}
          </div>
          <div className="d-flex justify-content-center my-2">
            <AppButton
              btnText="Add Coupon Sector"
              variant="primary"
              onClick={handleAddSectorDetails}
            />
          </div>
        </div>
      )}
    </div>
  );
}

AddCoupon.propTypes = {
  cloneCoupon: PropTypes.any.isRequired,
};

export default AddCoupon;
